import type { Icons } from '@assets/index';

export interface SidebarMenuItem {
    name: string;
    path: string;
    icon: keyof typeof Icons;
    module?: string;
    /** If true, only visible to users with role_name === 'Super Admin' */
    superAdminOnly?: boolean;
}

export interface SidebarMenuGroup {
    label?: string;
    items: SidebarMenuItem[];
}

/** Same rules as the Sidebar nav filter — keep in sync when menu changes. */
export function isSidebarMenuItemVisible(
    item: SidebarMenuItem,
    isSuperAdmin: boolean,
    hasPermission: (module: string, action: string) => boolean,
): boolean {
    if (item.superAdminOnly && !isSuperAdmin) return false;
    if (!item?.module) return true;
    return hasPermission(item.module, 'view');
}

const sidebarMenu: SidebarMenuGroup[] = [
    {
        label: 'FELLOWSHIP MANAGEMENT',
        items: [
            { name: 'Cohorts', path: '/admin/cohorts', icon: 'sidebarAudits' ,module:'cohorts'},
            { name: 'Student Applications', path: '/admin/applications', icon: 'sidebarReferenceDocs', module: 'applications' },
            { name: 'Students Directory', path: '/admin/students', icon: 'sidebarUsers', module: 'students' },
            { name: 'Evaluations', path: '/admin/evaluations', icon: 'sidebarReports', module: 'evaluations' },
        ],
    },
    {
        label: 'MASTERS',
        items: [
            { name: 'AI Fellowship Program', path: '/admin/courses', icon: 'sidebarDepartments' ,module:'courses'},
            { name: 'Mentors', path: '/admin/mentors', icon: 'sidebarUsers', module: 'mentors' },
            { name: 'Module Templates', path: '/admin/module-templates', icon: 'sidebarSection', module: 'module_templates' },
        ],
    },
    {
        label: 'SYSTEM',
        items: [
            { name: 'Master Password', path: '/admin/settings/master-password', icon: 'sidebarRoles', superAdminOnly: true },
        ],
    },
];

/** First menu path the user may open, in sidebar order (Dashboard → Management → …). */
export function getFirstAccessibleMenuPath(
    hasPermission: (module: string, action: string) => boolean,
    isSuperAdmin: boolean,
): string | null {
    for (const group of sidebarMenu) {
        for (const item of group.items) {
            if (isSidebarMenuItemVisible(item, isSuperAdmin, hasPermission)) {
                return item.path;
            }
        }
    }
    return null;
}

export default sidebarMenu;
